import { render, staticRenderFns } from "./ContactsFragmentFilterDropdown.vue?vue&type=template&id=2289eb9a&"
import script from "./ContactsFragmentFilterDropdown.vue?vue&type=script&lang=js&"
export * from "./ContactsFragmentFilterDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports